<div class="container">
    <div class="header">
        <h5 class="title">
            {{ 'duty-engineer.add-duty-engineer.dialog.input' | translate }}
        </h5>
    </div>
    <div class="content">
        <app-address-selectors
            [vesselSlots]="vesselSlots"
            [settingAddress]="settingAddress"
            [hasRowPadding]="false"
            (onSelectorChange)="onSelectorChange($event)"></app-address-selectors>
    </div>
</div>

<app-loading-spinner *ngIf="isLoading" class="spinner-component"></app-loading-spinner>

<div class="buttons-container">
    <button class="cancel button" (click)="cancel()">
        {{ 'shipyard.create.dialog.form.button.cancel' | translate }}
    </button>
    <button class="save button" (click)="save()" [disabled]="isLoading || !isFormTouched || hasError">
        {{ 'dlg.save' | translate }}
    </button>
</div>
